module.exports = __webpack_public_path__ + "static/img/manual_ja_2.0992ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_2.png
// module id = 3w6/
// module chunks = 4